module.exports = __webpack_public_path__ + "static/media/bst.9aeb529b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bst.png
 ** module id = 513
 ** module chunks = 0
 **/